<template lang="pug">
  b-form#DeliveryChangeDriverForm(@submit.stop.prevent="onSubmit")
    b-form-group(invalid-feedback="Este campo es requerido")
      .input-title Conductor
      v-select(v-model="form.driverId" :options="driverOptions" :reduce="driver => driver.value" style="min-height: 40px")
    .text-right
      b-button(type="submit" :disabled="loading") Guardar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'

export default {
  mixins: [MakeToastMixin],
  props: {
    deliveries: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      form: {
        driverId: null
      }
    }
  },
  validations: {
    form: {
      driverId: { required }
    }
  },
  methods: {
    ...mapActions(['listUser', 'driverBulkReassignDeliveries']),
    async onSubmit() {
      this.loading = true
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        const ok = await this.$root.$bvModal.msgBoxConfirm(this.confirmMessage)
        if (ok) {
          const response = await this.driverBulkReassignDeliveries({ data: { deliveriesIds: this.deliveries.map(d => d.id), newDriverId: this.form.driverId } })
          if (response.status >= 200 && response.status < 300) {
            this.makeSuccessToast(response.data.message || 'El conductor se actualizó correctamente')
            this.$emit('done')
          } else if (response.status >= 400) {
            this.makeDangerToast(response.data.message || 'Error al cambiar el conductor')
          }
        }
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters(['drivers', 'user']),
    confirmMessage() {
      return `¿Seguro que quieres cambiar el conductor de ${this.deliveries.length} envío${this.deliveries.length > 1 ? 's' : ''}?`
    },
    driverOptions() {
      const data = [{
        value: null,
        label: 'Selecciona un conductor'
      }]
      if (this.drivers)
        data.push(...this.drivers.filter(d => d.id !== this.user.id).map(driver => {
          return {
            value: driver.id,
            label: `${driver.name} ${driver.lastName}`
          }
        }))
      return data
    }
  },
  created() {
    this.listUser()
  }
}
</script>
